import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getChats } from '../../../services/chats';
import { IChat } from '../../../services/chats/types';

export const ThunkGetChats = createAsyncThunk<IChat[], { search: string; days?: number }>(
  `${storeResources.CHATS}/getChats`,
  ({ search, days }) =>
    getChats(search, days)
    .then(res => res.data)
    .then(res => res.sort((a, b) => (+a.id - +b.id ? 1 : -1))),
);
